import { Navigate, useLocation } from 'react-router-dom';
import { regionFromPathname } from '../../utils/regionFromPath';
import { categoriesHubPath } from '../../utils/categoriesPaths';

export default function RedirectToCategories() {
  const region = regionFromPathname(useLocation().pathname);
  return <Navigate to={categoriesHubPath(region)} replace />;
}
